import React, {useState} from 'react'
import PlusIcon from "../../../../statics/assets/icons/plus.svg"
import CustomerManagerFormModal from "./CustomerManagerFormModal"

const CustomerManagerForm = (props) => {
    const [showModal, toggleModal] = useState(false)

    const _toggleModal = () => {
        toggleModal(!showModal)
    }

    return <>
        <button className="ButtonCustom" onClick={_toggleModal}><PlusIcon width={12} height={12}/>Thêm mới</button>
        {showModal && <CustomerManagerFormModal showModal={showModal} toggleModal={_toggleModal} {...props}/>}
    </>
}

export default CustomerManagerForm
